import { format, isValid, parse } from 'date-fns';

export const formatSortTime = (value: string | null | undefined): string => {
  if (!value) return '';
  const date = parse(value, 'HH:mm:ss', new Date());
  return isValid(date) ? format(date, 'h:mm a') : value;
};

export const formatTechnicians = (row: { emp_id?: string | null; emp_id_secondary?: string | null }): string =>
  [row.emp_id, row.emp_id_secondary].filter((id): id is string => !!id).join(', ');

export const isCompleted = (status?: string) => {
  const s = (status || '').toLowerCase();
  return s === 'complete' || s === 'completed';
};
